<template>
  <el-row
type="flex"
justify="center">
    <el-tooltip
      v-for="button in data"
      :key="button.key"
      :content="button.label"
      effect="dark"
      placement="top"
    >
      <el-button
        :icon="button.icon"
        :type="button.type"
        :plain="button.plain"
        size="small"
        circle
        @click="$emit(button.key, item)"
      />
    </el-tooltip>
  </el-row>
</template>

<script>
import CONSTANTS from "@/config/constants";
export default {
  name: "ActionButtons",
  props: {
    item: Object,
    buttons: Array,
  },
  computed: {
    data() {
      return CONSTANTS.ALL_ACTIONS.filter((a) =>
        (this.buttons || []).includes(a.key)
      );
    },
  },
  methods: {},
};
</script>

<style lang="scss"></style>
